import React from 'react';
import { Link } from 'react-router-dom';
import usePrices from '../../hooks/usePrices';
import { PAGES, serverPath, gamePath, gameLabel } from '../../site/routes';
import { BANKS } from '../../site/content';
import { usePageSeo, Breadcrumbs, PageHeader, Section, TrustGrid, LinkCards, CtaBand, TextLink } from '../../site/ui';

const BREADCRUMBS = [
  { label: 'Accueil', to: PAGES.home },
  { label: 'Dofus Maroc', to: PAGES.dofusMaroc },
];

export default function DofusMarocPage() {
  const { servers } = usePrices();

  // Liens vers les serveurs cités dans le texte
  const serverLink = (slug) => {
    const server = servers.find(x => x.slug === slug);
    return server ? <TextLink to={serverPath(server)}>{server.name}</TextLink> : null;
  };

  usePageSeo({
    title: 'Dofus Maroc : acheter et vendre ses Kamas en dirhams | AV Kamas',
    description: "Dofus au Maroc : la communauté marocaine, le paiement des Kamas en DH par virement entre banques marocaines et un support dédié.",
    path: PAGES.dofusMaroc,
    breadcrumbs: BREADCRUMBS,
  });

  return (
    <main className="bg-gray-950 text-white">
      <Breadcrumbs items={BREADCRUMBS} />
      <PageHeader
        kicker="Dofus au Maroc"
        title={<>Dofus Maroc : <span className="text-yellow-400">une plateforme pensée pour les joueurs marocains</span></>}
      />

      <Section className="pt-0 md:pt-0">
        <div className="grid md:grid-cols-3 gap-5 md:gap-8 text-sm sm:text-base text-gray-300 leading-relaxed">
          <div>
            <h2 className="text-lg sm:text-xl font-semibold text-white mb-2">Les joueurs de Dofus au Maroc</h2>
            <p>
              La communauté <strong>Dofus Maroc</strong> joue sur tous les serveurs : {serverLink('imagiro')} et {serverLink('tal-kasha')} pour débuter,{' '}
              {serverLink('draconiros')}, {serverLink('dakal')} ou {serverLink('kourial')} pour le monocompte, {serverLink('fallanster')} et {serverLink('boune')} sur{' '}
              <TextLink to={gamePath('DOFUS RETRO')}>Dofus Rétro</TextLink>, {serverLink('kelerog')} et {serverLink('tiliwan')} sur mobile avec{' '}
              <TextLink to={gamePath('DOFUS TOUCH')}>Dofus Touch</TextLink>.
            </p>
          </div>
          <div>
            <h2 className="text-lg sm:text-xl font-semibold text-white mb-2">Payer ses Kamas en dirhams</h2>
            <p className="mb-2">
              Sans carte internationale ni conversion en euros : l'achat et la vente de Kamas se règlent en DH par virement entre banques
              marocaines, avec un RIB local.
            </p>
            <p className="text-xs sm:text-sm text-gray-400">{BANKS.join(' · ')}</p>
          </div>
          <div>
            <h2 className="text-lg sm:text-xl font-semibold text-white mb-2">Un support qui parle votre langue</h2>
            <p>
              Chaque commande ouvre une conversation avec notre équipe. Posez vos questions, envoyez vos preuves de paiement et suivez la
              livraison de vos Kamas. <Link to="/register" className="text-yellow-400 hover:underline">Créez votre compte gratuit</Link>.
            </p>
          </div>
        </div>
      </Section>

      <Section title={<>Achat et vente de Kamas <span className="text-yellow-400">en toute transparence</span></>} className="bg-gray-900/40">
        <TrustGrid />
      </Section>

      <Section title="Commencer sur votre jeu">
        <LinkCards
          links={[
            { to: gamePath('DOFUS 3'), title: `Kamas ${gameLabel('DOFUS 3')}`, text: '13 serveurs, du classique au monocompte.' },
            { to: gamePath('DOFUS RETRO'), title: `Kamas ${gameLabel('DOFUS RETRO')}`, text: 'Fallanster, Allisteria et Boune.' },
            { to: gamePath('DOFUS TOUCH'), title: `Kamas ${gameLabel('DOFUS TOUCH')}`, text: 'Kelerog, Tiliwan, Blair et Talok.' },
          ]}
        />
      </Section>

      <CtaBand />
    </main>
  );
}
